import { createTypes, createAction } from 'lib/action'

// *load ข้อมูลต้นแหล่ง
const MATERIAL_QUOTA_LOCATION = createTypes(
  'materialQuotaDashboardLoadLocation',
  'load'
)

// *load ข้อมูลวัตถุดิบ
const MATERIAL_QUOTA_RAW_MATERIAL = createTypes(
  'materialQuotaLoadRawMaterial',
  'load'
)

const LOAD_MATERIAL_QUOTA = createTypes('loadmaterialquota', 'load')
const EXPORT_MATERIAL_QUOTA = createTypes('exportmaterialquota', 'load')
const LOAD_MATERIAL_QUOTA_DETAIL = createTypes(
  'loadmaterialquotadetail',
  'load'
)
const MATERIAL_QUOTA_MANAGEMENT = createTypes(
  'materialquotamanagement',
  'create'
)
const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูลต้นแหล่ง
const materialQuotaLoadLocation = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_LOCATION.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_LOCATION.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const materialQuotaLoadRawMaterial = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_RAW_MATERIAL.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_RAW_MATERIAL.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_RAW_MATERIAL.FAITLURE),
}

const loadMaterialQuota = {
  request: (data, loading) =>
    createAction(LOAD_MATERIAL_QUOTA.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(LOAD_MATERIAL_QUOTA.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_MATERIAL_QUOTA.FAITLURE),
}

const exportMaterialQuota = {
  request: (data, loading) =>
    createAction(EXPORT_MATERIAL_QUOTA.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(EXPORT_MATERIAL_QUOTA.SUCCESS, { lists }),
  failure: () => createAction(EXPORT_MATERIAL_QUOTA.FAITLURE),
}

const loadMaterialQuotaDetail = {
  request: (data, loading) =>
    createAction(LOAD_MATERIAL_QUOTA_DETAIL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LOAD_MATERIAL_QUOTA_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(LOAD_MATERIAL_QUOTA_DETAIL.FAITLURE),
}

const materialQuotaManagement = {
  request: (data, loading) =>
    createAction(MATERIAL_QUOTA_MANAGEMENT.REQUEST, { data, loading }),
  success: (res) => createAction(MATERIAL_QUOTA_MANAGEMENT.SUCCESS, { res }),
  failure: () => createAction(MATERIAL_QUOTA_MANAGEMENT.FAITLURE),
}

export {
  REMOVE_LISTS,
  removeLists,
  LOAD_MATERIAL_QUOTA,
  loadMaterialQuota,
  EXPORT_MATERIAL_QUOTA,
  exportMaterialQuota,
  LOAD_MATERIAL_QUOTA_DETAIL,
  loadMaterialQuotaDetail,
  MATERIAL_QUOTA_MANAGEMENT,
  materialQuotaManagement,
  MATERIAL_QUOTA_LOCATION,
  materialQuotaLoadLocation,
  MATERIAL_QUOTA_RAW_MATERIAL,
  materialQuotaLoadRawMaterial,
}
